import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import { useGetTariffsPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.form-validation';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.model';
import { useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import * as css from './emsp-bo-tariff-list-filter-search-form-step-1.module.scss';

export const EmspBoTariffListFilterSearchFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { control } = useFormContext<GetTariffsPaginatedModel>();
    const inputRef = useRef<HTMLInputElement>(null);
    const { textToSearch } = useGetTariffsPaginatedFormValidation();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Controller
        name="textToSearch"
        control={control}
        rules={textToSearch}
        render={({ field }) => (
          <TextInput
            ref={inputRef}
            className={css.searchInput}
            leftIcon="search-md"
            value={field.value}
            placeholder={t(
              'delmonicos-shared-sdk.inputs-filterable-fields-pagination.text-to-search',
            )}
            onChange={(e) => field.onChange(e.target.value)}
            adornmentButtonType="button"
            adornmentOnClick={() => {
              field.onChange('');
              inputRef.current?.form?.requestSubmit();
            }}
            adornment={field.value !== '' && <Icon name="x-close" />}
          />
        )}
      />
    );
  };
